import React, {useRef, useState} from 'react';
import {useSelector} from 'react-redux';
import {View} from 'react-native';

import MapView from 'src/Modules/Native/MapView';

/////////////////////////////////////////////
///////  components

import {TopTab, TopTabButton} from 'src/Modules/TabViews';

////////////////// utils

import {
  BottomTabButton,
  BottomTab,
} from 'src/Modules/TabViews/FooterComponents';

import {MapMarker} from 'src/Modules/MapMarker';

import Photos from 'src/Modules/CommonGame/Photos';

import isIphoneX from 'src/Utils/IphoneXHelper';
const isX = isIphoneX();

/////////////////////////////////////////////
/////////////// utils

import useParams from 'src/Hooks/useParams';
import {navigationRef} from 'src/Nav/navigationHelpers';
import EventLeaderboard from './EventLeaderboard';
import CustomActivityIndicator from '../Modules/CommonView/CustomActivityIndicator';

const EventDashboard = () => {
  console.log('EventDashboard renender');
  const event = useSelector((state) => state.event);

  const {currentView: initialView} = useParams();
  const [currentView, setCurrentView] = useState(initialView || 'Leaderboard');
  const [showDeletedTeams, setShowDeletedTeams] = useState();
  const [selectedGroup, setSelectedGroup] = useState();

  // updating the event info stored in redux based on firebase state
  // data is stored at customEvents/$eventId

  // searching for groups based on eventId
  // then filtering through the groups
  // this is done so all groups can be shown

  let hunt = {...event?.info} || {};

  hunt.name = hunt.company ? hunt.company + '' : hunt.groupType + '';

  if (!event || !event.info) {
    return (
      <View style={{flex: 1, justifyContent: 'center', alignItems: 'center'}}>
        <CustomActivityIndicator />
      </View>
    );
  }

  return (
    <View style={{flex: 1, backgroundColor: global?.color?.white}}>
      <TopTab>
        <TopTabButton
          text={'Leaderboard'}
          active={currentView === 'Leaderboard'}
          handlePress={() => {
            setCurrentView('Leaderboard');
          }}
        />
        {!event.info?.locateTeamsOff && (
          <TopTabButton
            text={'Map'}
            active={currentView === 'Map'}
            handlePress={() => {
              setCurrentView('Map');
            }}
          />
        )}
        <TopTabButton
          text={'Photos'}
          active={currentView === 'Photos'}
          handlePress={() => {
            setCurrentView('Photos');
          }}
        />
      </TopTab>
      <View
        style={{
          flex: 1,
          position: 'relative',
          backgroundColor: global?.color?.white1,
        }}>
        {currentView == 'Map' && (
          <RenderMap
            selectedGroup={selectedGroup}
            showDeletedTeams={showDeletedTeams}
          />
        )}
        {currentView == 'Leaderboard' && (
          <EventLeaderboard
            showDeletedTeams={showDeletedTeams}
            setSelectedGroup={setSelectedGroup}
            setCurrentView={setCurrentView}
            selectedGroup={selectedGroup}
          />
        )}
        {currentView == 'Photos' && (
          <GroupPhotos key="groupPhotos" selectedGroup={selectedGroup} />
        )}
      </View>
      <BottomTab
        height={isX ? 75 : 65}
        tabStyle={{
          alignItems: 'flex-start',
          position: 'absolute',
          left: 0,
          right: 0,
          bottom: 0,
        }}>
        <BottomTabButton
          text={'Go Back'}
          iconName={'arrow-left-circle'}
          handlePress={() => navigationRef.goBack(null)}
          buttonStyle={{marginTop: 5}}
        />
        <BottomTabButton
          text={showDeletedTeams ? 'Hide Deleted Teams' : 'Show Deleted Teams'}
          iconName={showDeletedTeams ? 'minus' : 'plus'}
          handlePress={() => setShowDeletedTeams(!showDeletedTeams)}
          buttonStyle={{marginTop: 5}}
        />
        <BottomTabButton
          text={'Contact Support'}
          iconName={'phone'}
          handlePress={() => navigationRef.navigate('SupportModal')}
          buttonStyle={{marginTop: 5}}
        />
      </BottomTab>
    </View>
  );
};

export default EventDashboard;

const RenderMap = ({selectedGroup, showDeletedTeams}) => {
  const event = useSelector((state) => state.event);
  let {groups, info} = event;
  let initialRegion = {
    latitude: parseFloat(info?.lat || '39.7392'),
    longitude: parseFloat(info?.long || '-104.9903'),
    latitudeDelta: 0.0722,
    longitudeDelta: 0.0321,
  };
  if (selectedGroup && selectedGroup.position) {
    const position =
      typeof selectedGroup.position != 'object'
        ? JSON.parse(selectedGroup.position)
        : selectedGroup.position;
    initialRegion = {
      latitude: parseFloat(
        position.latitude || position.coords.latitude || '39.7392',
      ),
      longitude: parseFloat(
        position.longitude || position.coords.longitude || '-104.9903',
      ),
      latitudeDelta: 0.01,
      longitudeDelta: 0.005,
    };
  }

  const mapRef = useRef();

  return (
    <View style={{flex: 1, marginBottom: 0}}>
      <MapView
        key={selectedGroup}
        ref={mapRef}
        style={{flex: 1}}
        initialRegion={initialRegion}>
        {!!groups &&
          groups.map?.((group) => {
            if (group.deleted && !showDeletedTeams) {
              return;
            }

            // getting the position from the group
            var {position = {}} = group || {};

            // returning nothing if no position
            if (!position) {
              return console.log('no position');

              // parsing the object if a string
            } else if (typeof position != 'object') {
              position = JSON.parse(position);
            }
            const {coords = {}} = position || {};
            const latitude = parseFloat(
              position.latitude || coords.latitude || '0',
            );
            const longitude = parseFloat(
              position.longitude || coords.longitude || '0',
            );

            console.log('GroupMapRender', {
              teamName: group?.teamName,
              latitude,
              longitude,
              position,
            });

            if (latitude != 0 && longitude != 0) {
              //const position = typeof group.position != 'object' ? JSON.parse(group.position) : group.position

              return (
                <MapMarker
                  lat={latitude}
                  key={`${group.groupId}_mrkr`}
                  long={longitude}
                  showMarker={true}
                  title={'Team: ' + group.teamName}
                  identifier={JSON.stringify(group)}
                  setSelectedHuntId={() => {
                    mapRef?.current?.animateToRegion({
                      latitude: parseFloat(latitude || 1),
                      longitude: parseFloat(longitude || 1),
                      latitudeDelta: 0.01,
                      longitudeDelta: 0.005,
                    });
                  }}
                />
              );
            }
          })}
      </MapView>
    </View>
  );
};
const GroupPhotos = ({selectedGroup}) => {
  console.log('the event photos are');
  return (
    <View style={{flex: 1, marginBottom: 0}}>
      <Photos
        hideClose
        showFlag
        flag
        useEventPhotos
        selectedGroupId={selectedGroup?.groupId}
      />
    </View>
  );
};
